import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import {
  SiaOperator,
  SiaSizeDetectorService,
  SiaWindowSize,
} from '@sia/shared';
import { DxDataGridComponent } from 'devextreme-angular';
import { StartEditAction } from 'devextreme/common/grids';
import { Subscription } from 'rxjs/internal/Subscription';
import { GridConfigClass } from '../../interfaces/grid-config';
import { SiaBaseComponent } from '../sia-base/sia-base.component';

@Component({
  selector: 'base-grid-config-cols',
  template: `<div>base grid config works</div>`,
  styles: [],
  standalone: true,
})
export class SiaGridConfigTab
  extends SiaBaseComponent
  implements OnInit, OnDestroy
{
  private sizeDetectorService = inject(SiaSizeDetectorService);

  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent | undefined;
  protected _gridConfig: GridConfigClass | null = new GridConfigClass();

  protected _subs: Subscription[] = [];
  @Input() set gridConf(value: GridConfigClass) {
    this._gridConfig = value;
    if (this._gridConfig && this._gridConfig.gridId) {
      this.onGridConfigSetted();
      if (this._gridConfig.cols) {
        this._gridConfig.cols.forEach((col) => {
          if (!col.isFullText) {
            col.isFullText = false;
          }
        });
      }
    }
  }
  @Input() tempCols: any[] = [];
  @Input()
  tabsHeight: number = 0;
  windowSize: SiaWindowSize = {};
  gridConfAreaTypes: any[] = [
    { id: '', name: 'Nessuno' },
    { id: 'cell', name: 'Cella' },
    { id: 'row', name: 'Riga' },
    { id: 'column', name: 'Colonna' },
  ];

  gridConfAlignmentTypes: any[] = [
    { id: '', name: 'Nessuno' },
    { id: 'center', name: 'Cn' },
    { id: 'left', name: 'Sx' },
    { id: 'right', name: 'Dx' },
  ];

  gridConfFormatTypes: any[] = [
    { id: '', name: 'Nessuno' },
    { id: 'string', name: 'Str' },
    { id: 'number', name: 'Num' },
    { id: 'object', name: 'Obj' },
    { id: 'date', name: 'Date' },
    { id: 'datetime', name: 'dTime' },
    { id: 'boolean', name: 'bool' },
  ];

  gridConfEditorTypes: any[] = [
    { id: '', name: 'Default' },
    { id: 'lookup', name: 'Combobox' },
  ];

  gridConfTemplateTypes: any[] = [
    { id: '', name: 'Nessuno' },
    { id: 'PosNeg', name: 'Pos & Neg' },
    { id: 'DownloadLink', name: 'Download' },
    { id: 'RouterLink', name: 'DEPRECATO Navigazione' },
    { id: 'RouterLinkExternal', name: 'DEPRECATO Navigazione external' },
    { id: 'RouterLinkJsonConfig', name: 'Navigazione configurazione' },
    { id: 'CustomRouterLink', name: 'DEPRECATO Navigazione custom (adapters)' },
    { id: 'FullText', name: 'DEPRECATO Testo a capo' },
    { id: 'RouterIconLink', name: 'DEPRECATO Navigazione Icona' },
    {
      id: 'RouterIconLinkMaterial',
      name: 'DEPRECATO Navigazione Icona material',
    },
    {
      id: 'CustomRouterIconLink',
      name: 'DEPRECATO Navigazione Custom Icona Material (adapters)',
    },
    { id: 'FileExtension', name: 'Estensione File' },
    { id: 'EmailLink', name: 'Email' },
    { id: 'TelephoneLink', name: 'Telefono' },
    { id: 'Char2Bool', name: 'Char2Bool' },
    { id: 'Int2Date', name: 'Int2Date' },
    { id: 'ActionPK', name: 'ActionPK' },
    { id: 'Color', name: 'Colore' },
    { id: 'IconAndDescription', name: 'Icona e Descrizione' },
    { id: 'AvatarBig', name: 'DEPRECATO Avatar ' },
    { id: 'AvatarSmall', name: 'Avatar' },
    { id: 'ImageSmall', name: 'ImageSmall' },
    { id: 'IconMaterial', name: 'IconMaterial' },
    { id: 'Star', name: 'Stella' },
    { id: 'Icon', name: 'Icona' },
  ];

  gridConfEditTemplateTypes: any[] = [
    { id: '', name: 'Nessuno' },
    { id: 'Char2BoolEdit', name: 'Char2Bool' },
    { id: 'Int2DateEdit', name: 'Int2Date' },
    { id: 'ColorEdit', name: 'Colore' },
    { id: 'IconAndDescriptionEdit', name: 'Icona e Descrizione' },
    { id: 'Icon', name: 'Icona' },
    { id: 'StarEdit', name: 'Stella' },
  ];

  gridConfPatternsTypes: any[] = [
    { id: '', name: 'Nessuno' },
    { id: '#FirstOfYear', name: "Primo dell'anno" },
    { id: '#CurrentYearNumber', name: 'Anno corrente in numero' },
    { id: '#Today', name: 'Oggi' },
    { id: '#UserId', name: 'Id utente' },
    { id: '#RelationId', name: 'Id relazione utente' },
    { id: 'SessionParam', name: 'Parametro in sessione' },
    { id: 'StaticValue', name: 'Valore statico' },
    { id: '@FirstOfYear', name: "Primo dell'anno DEPRECATO" },
    { id: '@CurrentYearNumber', name: 'Anno corrente in numero DEPRECATO' },
    { id: '@Today', name: 'Oggi DEPRECATO' },
    { id: '@UserId', name: 'Id utente DEPRECATO' },
    { id: '@RelationId', name: 'Id relazione utente DEPRECATO' },
    { id: '@SessionParam', name: 'Parametro in sessione DEPRECATO' },
    { id: '@StaticValue', name: 'Valore statico DEPRECATO' },
  ];

  gridConfFiltersTypes: SiaOperator[] = [];

  get gridConf(): GridConfigClass {
    return this._gridConfig ?? new GridConfigClass();
  }
  protected _startEditAction: StartEditAction = 'click';
  protected _selectTextOnEditStart: boolean = false;

  @HostListener('window:unload')
  ngOnDestroy() {
    this._gridConfig = null;
    this.tempCols = [];
    this.tabsHeight = 0;
    this.gridConfAlignmentTypes = [];
    this.gridConfFormatTypes = [];
    this.gridConfEditorTypes = [];
    this.gridConfTemplateTypes = [];
    this.gridConfEditTemplateTypes = [];
    this.gridConfPatternsTypes = [];
    this.gridConfFiltersTypes = [];
    this._startEditAction = 'click';
    this._subs.forEach((sub) => {
      sub.unsubscribe();
    });
    super.ngOnDestroy();
  }
  ngOnInit(): void {
    let s0 = this.sizeDetectorService.onResize$.subscribe(
      (size: SiaWindowSize | null) => {
        if (size) {
          this.windowSize = size;
        }
      },
    );
    this._subs.push(s0);
  }

  get startEditAction() {
    return this._startEditAction;
  }

  get selectTextOnEditStart() {
    return this._selectTextOnEditStart;
  }

  get gridConfigJson(): string {
    return JSON.stringify(this.gridConf);
  }

  //#region protected methods
  protected onGridConfigSetted() {
    // consolewarn("CHIAMATA IMPLEMENTAZIONE BASE DEL METODO onGridConfigSetted");
  }
  //#endregion

  //#region public methods
  onConfigRowUpdating(e: any) {
    let data = e.data;
    if (data && data['dataField']) {
      data.dataField = data.dataField.toLowerCase();
    }
    this.updateGridConf(data);
  }

  onActionRowUpdating(e: any) {}

  updateGridConf(data: any) {
    let conf = this.gridConf;
    if (!conf?.cols) {
      return;
    }
    let updateItem = conf.cols.find((x) => x.dataField === data.dataField);
    if (!updateItem) {
      return;
    }
    let index = conf.cols.indexOf(updateItem);
    conf.cols[index] = data;
  }

  hideButtons(actions: any) {
    actions.toolbarOptions.items.forEach((action: any) => {
      if (action.name == 'saveButton' || action.name == 'revertButton') {
        action.visible = false;
      }
    });
  }

  saveData() {
    if (this.dataGrid?.instance.hasEditData()) {
      this.dataGrid.instance.saveEditData();
    }
  }
  //#region
}
